import { Paper, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import green from '@mui/material/colors/green';
import Container from "@mui/material/Container";
import Divider from '@mui/material/Divider';
import { styled } from "@mui/material/styles";
import * as React from 'react';
import { useSelector } from 'react-redux';
import i18n from '../../i18n';
import { ApplicationState } from '../../store';


const Item = styled(Paper)(({ theme }) => ({
   // backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    paddingTop: theme.spacing(20),
  //  paddingRight: theme.spacing(20),
    textAlign: 'center',
    // color: theme.palette.text.secondary,
}));
const ZoomMeetingLogout = () => {
    const appLanguage = useSelector((state: ApplicationState) => state.appData?.app4legalData?.lang);
    i18n.changeLanguage(localStorage.getItem("lang"));
    return (
        <Container style={{ paddingLeft: '200px', }} >
            <Item elevation={0} >
                <Typography variant="h4" style={{ color: green[500], width: 600, paddingRight: '40px' }} gutterBottom>

                    {i18n.t('app.zoomMeetingLoggedOut')}
                </Typography>
            </Item>
            <Divider sx={{
                width: 600,
            }} /><br/>
                <Box
                    sx={{
                        width: 600,
                        height: 70,
                        backgroundColor: '#F0F8FF',
                    }}                >
                <Typography variant="h6" style={{
                    color: 'black', paddingTop: '20px', display: "flex",
                    justifyContent: "center" }} gutterBottom>
                    {i18n.t('app.zoomLogout')}
                    </Typography>
                </Box>


        </Container>
    );
};
export default ZoomMeetingLogout;

